export default __webpack_public_path__ + "static/media/linkedin_icon_bw.60620006.svg";